// Shared reviewer-status → badge class. Callers pass their SCSS-module `styles`
// so each consumer keeps its own module-local class names.
export function getReviewerBadgeClass(status: string, styles: Record<string, string>): string {
  switch (status) {
    case 'REVIEWED':
      return styles.badgeSuccess ?? '';
    case 'VIEWED':
      return styles.badgeInfo ?? '';
    case 'PENDING':
      return styles.badgeNeutral ?? '';
    default:
      return styles.badgeWarning ?? '';
  }
}
